import { Box, Chip } from '@mui/material';
import React, { useState } from 'react';
import ReusableTable from '../../common/table/CommonTable';

const DoctorStaffList = () => {
  const [loading, setLoading] = useState(false);
const [data, setData] = useState([
  { id: 1, name: 'John Doe', email: 'john.doe@example.com', phone: '8234567890', status: 'Active', block: 'Block A', ward: 'Ward 1', floor: 'Floor 1' },
  { id: 2, name: 'Jane Smith', email: 'jane.smith@example.com', phone: '9876543210', status: 'Inactive', block: 'Block B', ward: 'Ward 2', floor: 'Floor 2' },
  { id: 3, name: 'Robert Johnson', email: 'robert.johnson@example.com', phone: '6551234567', status: 'Active', block: 'Block A', ward: 'Ward 1', floor: 'Floor 1' },
  { id: 4, name: 'Emily Davis', email: 'emily.davis@example.com', phone: '7552345678', status: 'Inactive', block: 'Block B', ward: 'Ward 2', floor: 'Floor 2' },
  { id: 5, name: 'Michael Brown', email: 'michael.brown@example.com', phone: '8553456789', status: 'Active', block: 'Block A', ward: 'Ward 1', floor: 'Floor 1' }
]);

const columns = [
  { id: 'id', label: 'Staff ID', sortable: true },
  { id: 'name', label: 'Name', sortable: true },
  { id: 'email', label: 'Email', sortable: true },
  { id: 'phone', label: 'Phone Number', sortable: true },
  { id: 'block', label: 'Block', sortable: true },
  { id: 'ward', label: 'Ward', sortable: true },
  { id: 'floor', label: 'Floor', sortable: true },
  { 
    id: 'status', 
    label: 'Status', 
    sortable: true,
    render: (value) => (
      <Chip label={value} color={value === 'Active' ? 'success' : 'warning'} />
    )
  }
];

  return (
    <Box>
      <ReusableTable
        title="Staffs"
        columns={columns}
        data={data}
        isLoading={loading}
        headerColor="#000" 
        rowColor="#ffffff" 
        alternateRowColor="#f5f5f5" 
        withPagination={true}
        withActions={true}
        rowsPerPage={10}
        showDownloadOption={true} 
      />
    </Box>
  );
};

export default DoctorStaffList;
